/* eslint-disable */

// Fix build on Safari <=12
import 'globalthis/auto';

// Fix build on Safari <=12
if (typeof window.queueMicrotask !== 'function') {
  window.queueMicrotask = cb => Promise.resolve().then(cb);
}

// Fix build on Safari <=15
if (typeof Object.hasOwn !== 'function') {
  Object.hasOwn = (obj, property) => obj?.hasOwnProperty(property);
}

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** Evergreen browsers require these. **/
import 'web-animations-js'

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js'
// import 'zone.js/dist/long-stack-trace-zone' // async stack traces with zone.js

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
// import 'intl';  // Run `npm install --save intl`.

/**
 * Need to import at least one locale-data with intl.
 */
// import 'intl/locale-data/jsonp/en';
import 'hammerjs'

// IntersectionObserver polyfill
import 'intersection-observer'

// @ts-ignore
if (!Object.fromEntries) {
  Object.defineProperty(Object, 'fromEntries', {
    // @ts-ignore
    value(entries) {
      if (!entries || !entries[Symbol.iterator]) {
        throw new Error('Object.fromEntries() requires a single iterable argument')
      }

      const o = {}

      Object.keys(entries).forEach(key => {
        const [k, v] = entries[key]

        // @ts-ignore
        o[k] = v
      })

      return o
    },
  })
}
